export default "__VITE_ASSET__MESflTaS__"